import request from '@/utils/request'

export function searchBranch(queryString, type) {
  return request({
    url: 'branch/search/' + queryString,
    method: 'get'
  })
}